export class Message {

	constructor(public title: string, public body: string | string[]) {

	}
}